import * as React from 'react';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { rem, SCREEN_BOTTOM_PADDING } from 'design-system';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import ListLoader from 'design-system/ListLoader';
import TrendingStock from './TrendingStock';
import { isWeb } from '../../../constants';
const DiscoverCategoryList = ({ assets, isInitial, index, combinedScrollY }) => {
    const [mounted, setMounted] = React.useState(isInitial);
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            setMounted(true);
        }, 300);
        return () => {
            clearTimeout(timeout);
        };
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const containerStyles = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle, styles.container);
    const assetsLength = assets.length;
    const scrollHandler = useAnimatedScrollHandler(({ contentOffset }) => {
        const itemIndex = index;
        // eslint-disable-next-line no-param-reassign
        combinedScrollY.value = {
            ...combinedScrollY.value,
            [itemIndex]: contentOffset.y,
        };
    }, [index]);
    return (<Animated.ScrollView scrollEventThrottle={16} style={containerStyles} onScroll={scrollHandler}>
      {!!mounted &&
            (assets?.length ? (assets.map((asset, index) => (<TrendingStock key={asset.id} assetId={asset.id} isFirstItem={index === 0} isLastItem={index === assetsLength - 1}/>))) : (<ListLoader smallMargin/>))}
    </Animated.ScrollView>);
};
export default DiscoverCategoryList;
const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: rem(16),
    },
});
